export default {"src":"/_next/static/media/transcript-bg.001385eb.svg","height":405,"width":439,"blurWidth":0,"blurHeight":0};